module.exports = __webpack_public_path__ + "static/media/ON_logo_color_small.a6f21367.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/ON_logo_color_small.png
// module id = 610
// module chunks = 0